export default "__VITE_ASSET__knyrfNQc__"